import SessionDocuments from "@/views/apps/session_documents/SessionDocuments.vue";
import MisDocuments from "@/views/apps/session_documents/MisDocuments.vue";
import DocumentosGenerales from "@/views/apps/session_documents/DocumentosGenerales.vue";
import DocumentBySupervisor from "@/views/apps/session_documents/DocumentBySupervisor.vue";
import layouts from "../../layout";

export default {
  path: "/documents",
  name: "session-documents",
  component: SessionDocuments,
  redirect: {
    name: "session-documents-mis-documentos"
  },
  meta: {
    auth: true,
    searchable: true,
    title: "Documentos",
    layout: layouts.navLeft,
    tags: ["Documentos", "Mis Documentos", "Documentos Generales"]
  },
  children: [
    {
      path: "all-documents",
      name: "session-documents-mis-documentos",
      component: MisDocuments,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Mis Documentos",
        tags: ["Documentos", "Mis Documentos", "Documentos Generales"],
        index: true
      }
    },
    {
      path: "documents-by-supervisor",
      name: "session-documents-documents-by-supervisor",
      component: DocumentBySupervisor,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documentos del Supervisor",
        tags: ["Documentos", "Mis Documentos", "Documentos Generales"],
        index: true
      }
    },
    {
      path: "documents-generals",
      name: "session-documents-documentos-generales",
      component: DocumentosGenerales,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documentos Generales",
        tags: ["Documentos", "Mis Documentos", "Documentos Generales"],
        index: true
      }
    }
  ]
};
